import { shortSymbolFormatted } from "common/constants";

interface SelectListMetalsProps {
    selectedListMetals: DefaultMetalsList[];
    setSelectedListMetals: (value: DefaultMetalsList[]) => void;
  }
  
  function SelectListMetals({
      selectedListMetals, 
      setSelectedListMetals
  }: SelectListMetalsProps) {
    const metalsList: DefaultMetalsList[] = ['AU', 'AG', 'PT', 'PD'];
  
    return (
      <div className='flex lg:flex-col space-y-2 w-2/3 lg:w-auto'>
        <div className='flex space-x-2 lg:space-x-4 items-center'>
            {metalsList.map((item) => (
              <ListItem
                key={item}
                item={item}
                selectedListMetals={selectedListMetals}
                setSelectedListMetals={setSelectedListMetals}
              />
            ))}
        </div>
      </div>
    );
  }
  
  interface ListItemProps {
    item: DefaultMetalsList;
    selectedListMetals: DefaultMetalsList[];
    setSelectedListMetals: (value: DefaultMetalsList[]) => void;
  }
  const ListItem = ({
    item,
    selectedListMetals, 
    setSelectedListMetals,
  }: ListItemProps) => {
    return (
      <div className='flex items-center'>
        <label className='text-[12px] lg:text-[13px] flex items-center'>
          <input
            disabled={
              selectedListMetals.includes(item) && selectedListMetals.length <= 1
            }
            type='checkbox'
            value={item}
            checked={selectedListMetals.includes(item)}
            onChange={(e) => {
              if (e.target.checked) {
                setSelectedListMetals([...selectedListMetals, item]);
              } else {
                setSelectedListMetals(
                  selectedListMetals.filter((el) => el !== item)
                );
              }
            }}
            className='mx-1 h-[15px] w-[15px] cursor-pointer'
          />
          {shortSymbolFormatted[item] || item}
        </label>
      </div>
    );
  };
  
  export default SelectListMetals;